// Google Apps Script web app that appends each answer as a row in the survey Google Sheet.
const SOURCE_SURVEY_ENDPOINT = 'https://script.google.com/macros/s/AKfycbyf5o6iwIXFXVQtVyzoXXMwzUa6Ni1fY3vspjyJY-kFWbczsZfIaO4HorgWCBRuYpGq/exec';

// Fire-and-forget: the answer is optional, so any failure is swallowed and never blocks the signup flow.
// Posted as text/plain with no-cors to skip the CORS preflight (the script reads e.postData.contents).
export const sendSourceSurvey = ({ email, option, detail }) => {
  try {
    fetch(SOURCE_SURVEY_ENDPOINT, {
      method: 'POST',
      mode: 'no-cors',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({
        email: email || '',
        option,
        detail: detail || '',
        timestamp: new Date().toISOString(),
        source: 'webapp',
      }),
    }).catch(() => {});
  } catch (e) {
    // Ignored on purpose.
  }
};

export default sendSourceSurvey;
